import React, { useEffect, useState, useCallback } from 'react';
import { Snackbar, TextField, MenuItem, Select, InputLabel, FormControl, Alert, CircularProgress, Typography, Button, Grid2, Autocomplete, createFilterOptions, Input, Dialog, DialogTitle, DialogContent, DialogActions, Stack, Table, TableHead, TableRow, TableCell, Checkbox, TableBody, Box, IconButton } from '@mui/material';
import { jobServices } from '../../services/jobServices';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../services/authentication/authContext';
import { userServices } from '../../services/userServices';
import { fetchJobStatusData } from '../redux/jobStatusSlice';
import { useSelector, useDispatch } from 'react-redux';
import JobCheckList from './JobCheckList';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import CalculateBudgetHours from './CalculateBudgetHours';
import '../../css/Form.css';
import { jwtDecode } from 'jwt-decode';
import { GetApp } from '@mui/icons-material';
import { downloadReport } from '../../utils/downloadReport ';
import ConfirmationDialog from '../common/ConfirmationDialog';
import PageHeader from '../ui/PageHeader';
import ActionProgressDialog from '../common/ActionProgressDialog';

const JobStatus = () => {
  const [roles, setRoles] = useState([]);
  const isAdmin = Array.isArray(roles) && (roles.includes('ADMIN') || roles.includes('SUPER_ADMIN'));
  const isSubAdmin = Array.isArray(roles) && roles.includes('SUB_ADMIN');
  const [jobData, setJobData] = useState([]);
  const [shortListedJobs, setShortListedJobs] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [selectedJobId, setSelectedJobId] = useState('');
  const [expectedEndDate, setExpectedEndDate] = useState('');
  const [assignedUserId, setAssignedUserId] = useState('');
  const [inactiveAssignedUser, setInactiveAssignedUser] = useState(null);
  const [status, setStatus] = useState('');
  const [currentStatusValue, setCurrentStatusValue] = useState('');
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { accessToken } = useAuth();
  const { t } = useTranslation();
  const [existingData, setExistingData] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [isCheckListChecked] = useState(false);
  const [checkType, setCheckType] = useState('');
  const [showButton, setShowButton] = useState(false);
  const dispatch = useDispatch();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [budgetHours, setBudgetHours] = useState('');
  const [jobCompletedDate, setJobCompletedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });
  const [budgetUpdatedAt, setBudgetUpdatedAt] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });
  const [budgetUpdatedByUser, setBudgetUpdatedByUser] = useState('');
  const [chargeHours, setChargeHours] = useState('00:00');
  const [chargeHoursError, setChargeHoursError] = useState('');
  const [jobInput, setJobInput] = useState('');
  const [internalJobInput, setInternalJobInput] = useState('');
  const [jobLoading, setJobLoading] = useState(false);
  const [existingDataBudgetHours, setExistingDataBudgetHours] = useState(null);
  const { data: jobStatusData } = useSelector(state => state.jobStatus);
  const [filteredStatuses, setFilteredStatuses] = useState([]);
  const [allJobs, setAllJobs] = useState([]);
  const [clientJobs, setClientJobs] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState('');
  const [selectedJobType, setSelectedJobType] = useState('');
  const [openDialogFileUpload, setOpenDialogFileUpload] = useState(false);
  const [openReviewDialog, setOpenReviewDialog] = useState(false);
  const [pendingJobData, setPendingJobData] = useState(null);
  const [openReasonDialog, setOpenReasonDialog] = useState(false);
  const [reasonText, setReasonText] = useState("");
  const [pendingFormData, setPendingFormData] = useState(null);
  const [unreviewedJobs, setUnreviewedJobs] = useState([]);
  const [selectedUnreviewedJobs, setSelectedUnreviewedJobs] = useState([]);
  const [openUnreviewedModal, setOpenUnreviewedModal] = useState(false);
  const [fileUpload, setFileUpload] = useState();
  const [fileName, setFileName] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [actionMessage, setActionMessage] = useState('');

  const fetchData = useCallback(async () => {
    if (!accessToken) return;
    try {
      setLoading(true);
      setJobLoading(true);

      const statusPromise = (jobStatusData || []).length === 0 && accessToken
        ? dispatch(fetchJobStatusData(accessToken))
        : Promise.resolve();

      const [clients, allJobs, users] = await Promise.all([
        jobServices.getClientsForJobTrackScreen(),
        jobServices.getAllJobsForStatusUpdate(),
        userServices.getUsersByRoleName(),
        statusPromise
      ]);

      setClientList(clients || []);
      setJobData(allJobs || []);
      setAllJobs(allJobs || []);
      setClientJobs(allJobs || []);
      setUserData(users || []);

    } catch (error) {
      console.error("Error fetching data:", error);
      setClientList([]);
      setJobData([]);
      setAllJobs([]);
      setClientJobs([]);
      setUserData([]);
    } finally {
      setLoading(false);
      setJobLoading(false);
    }
  }, [accessToken, dispatch, jobStatusData]);

  useEffect(() => {
    if (accessToken) {
      const decodedToken = jwtDecode(accessToken);
      let extractedRoles = [];

      if (Array.isArray(decodedToken.roles)) {
        extractedRoles = decodedToken.roles;
      } else if (typeof decodedToken.roles === "string") {
        extractedRoles = decodedToken.roles.split(",").map(role => role.trim());
      }

      setRoles(extractedRoles);
    }
  }, [accessToken]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFileUpload = () => {
    setOpenDialogFileUpload(true);
  };

  const handleCloseDialogFileUpload = () => {
    setOpenDialogFileUpload(false);
    setFileUpload(null);
  };

  const handleFileUploadChange = (event) => {
    setFileUpload(event.target.files[0]);
  };

  const handleFileUploadApi = async () => {
    if (!fileUpload || isUploading) return;

    setIsUploading(true);
    setActionMessage('Uploading Bulk Job Statuses...');
    setLoading(true);

    const formData = new FormData();
    formData.append("file", fileUpload);

    try {
      const response = await jobServices.bulkJobCompletedFileUpload(formData);

      if (response === "File processed successfully.") {
        setSnackbarMessage("File uploaded successfully");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);

        setTimeout(() => setOpenSnackbar(false), 4000);

        setOpenDialogFileUpload(false);
        setFileUpload(null);
        fetchData();
      }

      if (response?.unreviewedJobs?.length > 0) {
        setUnreviewedJobs(response.unreviewedJobs);
        setSelectedUnreviewedJobs([]);
        setOpenUnreviewedModal(true);

        setOpenDialogFileUpload(false);
        setFileUpload(null);
        fetchData();
      }

      if (response?.errorFile) {
        setFileName(response.errorFile);

        setSnackbarMessage("File uploaded successfully! You can download the error file.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);

        setTimeout(() => setOpenSnackbar(false), 4000);

        setOpenDialogFileUpload(false);
        setFileUpload(null);
        fetchData();
      }

    } catch (error) {
      console.error(error);

      setSnackbarMessage("Error uploading file. Please try again.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);

      setTimeout(() => setOpenSnackbar(false), 4000);
    } finally {
      setIsUploading(false);
      setLoading(false);
    }
  };

  const handleErrorFile = async () => {
    if (fileName) {
      try {
        setIsUploading(true);
        setActionMessage('Downloading Error File...');
        const response = await jobServices.downloadBulkJobCompletedErrorFIle(fileName);

        downloadReport(response);
        setSnackbarMessage("Error file is being downloaded.");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);

        setTimeout(() => {
          setSnackbarMessage(null);
          setOpenSnackbar(false);
        }, 4000);
        setFileName(null);
      } catch (error) {
        setSnackbarMessage("Error downloading the error file. Please try again.");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);

        setTimeout(() => {
          setSnackbarMessage(null);
          setOpenSnackbar(false);
        }, 4000);
      } finally {
        setIsUploading(false);
      }
    } else {
      setSnackbarMessage("No error file to download.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);

      setTimeout(() => {
        setSnackbarMessage(null);
        setOpenSnackbar(false);
      }, 4000);
    }
  }

  const handleBulkJobFormat = async () => {
    try {
      setIsUploading(true);
      setActionMessage('Downloading Format...');
      const response = await jobServices.downloadBulkJobCompletedFormat();
      handleCloseDialogFileUpload();
      downloadReport(response);
    } catch (error) {
      console.error("Error downloading bulk job formate");
    } finally {
      setIsUploading(false);
    }
  }

  const handleClientChange = e => {
    const clientId = e.target.value;
    setSelectedClientId(clientId);
    const filtered = allJobs.filter(j => j.clientId === clientId);
    setClientJobs(filtered);
    setJobType([...new Set(filtered.map(j => j.type))]);
    setJobLoading(true);

    setSelectedJobType('');
    setInactiveAssignedUser(null);
    setSelectedJobId('');
    setShortListedJobs([]);
    setStatus('');
    setExpectedEndDate('');
    setAssignedUserId('');
    setFilteredStatuses([]);
    setBudgetHours('');

  };

  const handleTypeChange = e => {
    const selectedType = e.target.value;
    setSelectedJobType(selectedType)
    const filtered = clientJobs.filter(j => j.type === selectedType);
    setShortListedJobs(filtered);
    setAssignedUserId('');
    setInactiveAssignedUser(null);
    setStatus('');
    setExpectedEndDate('');
    setBudgetHours('');
    setSelectedJobId('');
  };

  const handleJobChange = (e) => {
    const jobId = e.target.value;
    setSelectedJobId(jobId);

    const selectedJob = jobData.find((job) => job.jobId === jobId);
    const statusValue = selectedJob ? selectedJob.status : '';
    const selectedJobType = selectedJob ? selectedJob?.type : '';
    const selectedClientNameByJob = selectedJob?.clientId;
    const selectedExpectedEndDate = selectedJob ? selectedJob?.expectedEndDate : '';

    const budgetUpdatedByUser = selectedJob?.budgetUpdatedByFirstName
      ? `${selectedJob.budgetUpdatedByFirstName} ${selectedJob.budgetUpdatedByLastName}`
      : '';
    setBudgetUpdatedByUser(budgetUpdatedByUser);

    setSelectedClientId(selectedClientNameByJob);
    setSelectedJobType(selectedJobType);
    if (isAdmin || isSubAdmin) {
      setStatus("Completed");
    } else {
      setStatus(statusValue);
    }
    setCurrentStatusValue(statusValue);

    const normalize = str => str?.trim().toLowerCase();

    const currentStatusObj = jobStatusData.find(s =>
      normalize(s.label) === normalize(selectedJob.status)
    );
    const currentStatusValue = currentStatusObj?.value ?? null;

    if (currentStatusValue !== null) {
      if (isAdmin || isSubAdmin) {
        // Admin can see all statuses
        setFilteredStatuses(jobStatusData);
      } else {
        let newStatuses = [];

        if (currentStatusValue <= 12) {
          newStatuses = jobStatusData.filter(
            status => parseInt(status.value) <= 12 && parseInt(status.value) !== currentStatusValue
          );
        } else if (currentStatusValue >= 13) {
          newStatuses = jobStatusData.filter(
            status => parseInt(status.value) >= currentStatusValue
          );
        }

        const currentStatus = jobStatusData.find(s => parseInt(s.value) === currentStatusValue);
        if (currentStatus && !newStatuses.some(s => s.value === currentStatus.value)) {
          newStatuses.unshift(currentStatus);
        }

        setFilteredStatuses(newStatuses);
      }
    }

    setAssignedUserId(selectedJob.userId || '');

    const assignedUserId = selectedJob?.userId;
    const activeUserExists = userData.some(u => u.id === assignedUserId);

    if (!activeUserExists && assignedUserId) {
      // Create inactive user object from job data
      setInactiveAssignedUser({
        id: assignedUserId,
        firstName: selectedJob?.assignedByFirstName || '',
        middleName: '',
        lastName: selectedJob?.assignedByLastName || ''
      });
    } else {
      setInactiveAssignedUser(null);
    }

    const rawJson = selectedJob?.budgetHoursJson;
    const parsedJson = typeof rawJson === 'string'
      ? JSON.parse(rawJson)
      : rawJson;
    setExistingDataBudgetHours(
      Array.isArray(parsedJson) && parsedJson.length === 0 ? null : parsedJson
    );

    setExpectedEndDate(new Date(selectedExpectedEndDate.split(' ')[0]).toISOString().split('T')[0]);

    if (selectedJob?.jobCompletedDate != null) {
      const localDate = new Date(selectedJob?.jobCompletedDate);
      const dateOnly = localDate.getFullYear() +
        '-' + String(localDate.getMonth() + 1).padStart(2, '0') +
        '-' + String(localDate.getDate()).padStart(2, '0');
      setJobCompletedDate(dateOnly);
    } else {
      const today = new Date();
      setJobCompletedDate(today.toISOString().split('T')[0]);
    }

    if (selectedJob?.budgetUpdatedAt != null) {
      const localDate = new Date(selectedJob?.budgetUpdatedAt);
      const dateOnly = String(localDate.getDate()).padStart(2, '0') +
        '/' + String(localDate.getMonth() + 1).padStart(2, '0') +
        '/' + localDate.getFullYear();
      setBudgetUpdatedAt(dateOnly);
    } else {
      setBudgetUpdatedAt('');
    }

    const convertDecimalToTime = (decimalHours) => {
      if (decimalHours == null) return '00:00';
      const totalMinutes = Math.round(decimalHours * 60);
      const hh = Math.floor(totalMinutes / 60);
      const mm = totalMinutes % 60;
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(hh)}:${pad(mm)}`;
    };

    const rawCharge = selectedJob?.chargeHours;
    setChargeHours(convertDecimalToTime(rawCharge));

    const currentStatusBudgetHours = selectedJob?.budgetHours ? selectedJob?.budgetHours : '';
    setBudgetHours(currentStatusBudgetHours);

    const jobType = selectedJob ? selectedJob.type : '';
    setCheckType(jobType);

    if ((jobType === "Bookkeeping" || jobType === "VAT" || jobType === "Statutory/Final Accounts") && selectedJob.status === "Final review") {
      setShowButton(true);
    } else {
      setShowButton(false);
    }

  };

  const handleUserChange = (e) => {
    setAssignedUserId(e.target.value);
  };

  const handleStatusChange = (e) => {
    if (!(e.target.value === "Completed" || e.target.value === "Second Phase")) {
      setShowButton(false);
    }

    setStatus(e.target.value);
  };

  const removeDetailsBudgetHours = (data) => {
    if (!data) {
      return null;
    }
    return data.map(category => ({
      ...category,
      data: category.data ? category.data.map(({ details, ...rest }) => rest) : [] // Ensure `data` is an array before calling map
    }));
  };

  const jobFilter = (options, { inputValue }) => {
    return options.filter((option) =>
      option?.jobName?.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const convertTimeToDecimal = (timeString) => {
    if (!timeString) return null;
    // Accept 1-3+ digits for hours, exactly two digits for minutes (00-59)
    const match = timeString.trim().match(/^(\d{1,3}):([0-5][0-9])$/);
    if (!match) return null;
    const hh = Number(match[1]);
    const mm = Number(match[2]);
    return parseFloat((hh + mm / 60).toFixed(2));
  };

  const handleChargeHoursChange = (e) => {
    const val = e.target.value;
    setChargeHours(val);

    if (!val) {
      setChargeHoursError('');
      return;
    }
    const isValid = /^(\d{1,3}):([0-5][0-9])$/.test(val.trim());
    setChargeHoursError(isValid ? '' : 'Enter as HH:MM (minutes 00-59)');
  };

  const jobOptions = (shortListedJobs.length > 0 ? shortListedJobs : jobData);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (chargeHours) {
      const chargeHoursDecimal = convertTimeToDecimal(chargeHours);
      if (chargeHoursDecimal === null) {
        setSnackbarMessage('Invalid Charge Hours format. Use HH:MM (minutes 00-59).');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
        return;
      }
    }

    const checklistJson = removeDetails(existingData);
    const budgetHoursJson = removeDetailsBudgetHours(existingDataBudgetHours);
    const chargeHoursDecimal = convertTimeToDecimal(chargeHours);

    const formData = {
      id: selectedJobId,
      assignedUserId: assignedUserId,
      status,
      checklistJson,
      budgetHours,
      budgetHoursJson,
      expectedEndDate,
      jobCompletedDate: new Date(jobCompletedDate).toISOString(),
      chargeHours: chargeHoursDecimal
    };

    if (
      currentStatusValue && !isAdmin &&
      currentStatusValue.toLowerCase() === "review" &&
      status.toLowerCase() !== "final review" &&
      status.toLowerCase() !== "completed" &&
      status.toLowerCase() !== "review"
    ) {
      setPendingFormData(formData);
      setOpenReasonDialog(true);
      return;
    }

    if (currentStatusValue && accessToken) {
      jobServices.updateJobStatus(formData)
        .then(async () => {
          setSnackbarMessage("Job status updated successfully!");
          setSnackbarSeverity('success');
          setOpenSnackbar(true);

          if (isAdmin || isSubAdmin) {
            const allJobs = await jobServices.getAllJobsForStatusUpdate();
            setJobData(allJobs);
          }
          setTimeout(() => {
            setSnackbarMessage(null);
            setOpenSnackbar(false);
          }, 5000);
          setSelectedJobId('');
          setSelectedJobType('');
          setShortListedJobs([]);
          setJobType([]);
          setSelectedClientId('');
          setShowButton(false);
          setStatus('');
          setExistingData('');
          setAssignedUserId('');
          setBudgetHours('');
          setChargeHours('00:00');

          fetchData();
        })
        .catch((error) => {
          if ((error.response && error.response.status === 409) || error.response.status === 333) {
            // Handle 409 Conflict error
            setSnackbarMessage(error.response.data);
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
          } else if (error.response.status === 428) {
            // Review not done
            setPendingJobData(formData);
            setOpenReviewDialog(true);
          } else if (error.response.status === 400) {
            setSnackbarMessage(error.response.data);
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
          } else {
            // Handle other errors
            setSnackbarMessage("An error occurred. Please try again.");
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
          }
          if (error.response.status === 333) {
            setShowButton(true);
          }

          setTimeout(() => {
            setSnackbarMessage(null);
            setOpenSnackbar(false);
          }, 5000);
        });
    }
  };

  const handleConfirmReviewAnyway = async () => {
    if (!pendingJobData) return;
    try {
      const response = await jobServices.updateJobStatus({
        ...pendingJobData,
        skipReviewCheck: true
      });
      setSnackbarMessage("Job marked as completed (review skipped).");
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      setOpenReviewDialog(false);
      setPendingJobData(null);
      setSelectedJobId('');
      setSelectedJobType('');
      setShortListedJobs([]);
      setJobType([]);
      setSelectedClientId('');
      setShowButton(false);
      setStatus('');
      setExistingData('');
      setAssignedUserId('');
      setBudgetHours('');
      setChargeHours('00:00');
      fetchData();
    } catch (error) {
      setSnackbarMessage("Failed to complete job. Please try again.");
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleConfirmWithReason = async () => {
    if (!pendingFormData) return;

    try {
      const response = await jobServices.updateJobStatus({
        ...pendingFormData,
        reason: reasonText
      });

      setSnackbarMessage("Job status updated successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);

      setOpenReasonDialog(false);
      setReasonText("");
      setPendingFormData(null);
      setSelectedJobId('');
      setSelectedJobType('');
      setShortListedJobs([]);
      setJobType([]);
      setSelectedClientId('');
      setShowButton(false);
      setStatus('');
      setExistingData('');
      setAssignedUserId('');
      setBudgetHours('');
      setChargeHours('00:00');

      fetchData();
    } catch (error) {
      setSnackbarMessage("Failed to update job.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const removeDetails = (data) => {
    if (!data || !Array.isArray(data.categories)) {
      return null;
    }
    return data.categories.map(category => ({
      ...category,
      data: category.data ? category.data.map(({ particuler, ...rest }) => rest) : [] // Ensure `data` is an array before calling map
    }));
  };

  useEffect(() => {
    if (selectedJobId) {
      const selectedJob = jobData.find((job) => job.jobId === selectedJobId);
      const normalize = str => str?.trim().toLowerCase();

      const currentStatusObj = (jobStatusData || []).find(s =>
        normalize(s.label) === normalize(selectedJob.status)
      );
      const currentStatusValue = currentStatusObj?.value ?? null;
      if (currentStatusValue !== null) {
        if (isAdmin || isSubAdmin) {
          // Admin can see all statuses
          setFilteredStatuses(jobStatusData);
        } else {
          let newStatuses = [];
          if (currentStatusValue <= 12) {
            newStatuses = jobStatusData.filter(
              status => parseInt(status.value) <= 12 && parseInt(status.value) !== currentStatusValue
            );
          } else if (currentStatusValue >= 13) {
            newStatuses = jobStatusData.filter(
              status => parseInt(status.value) >= currentStatusValue
            );
          }

          const currentStatus = jobStatusData.find(s => parseInt(s.value) === currentStatusValue);
          if (currentStatus && !newStatuses.some(s => s.value === currentStatus.value)) {
            newStatuses.unshift(currentStatus);
          }

          setFilteredStatuses(newStatuses);
        }
      }
    }
  }, [selectedJobId, jobData, status]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Save updated data when modal is closed
  const handleSaveData = (updatedData, isCheckListChecked) => {
    setExistingData(updatedData);
    handleCloseModal();
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSaveDataJobPlan = (updatedData) => {
    setExistingDataBudgetHours(updatedData.categories);
    setBudgetHours(updatedData ? updatedData.totalTime.replace(":", ".") : '');
    handleCloseModal(); // Close the modal after saving
  };

  const formatCompletedDate = (completedDate) => {
    if (currentStatusValue.toLowerCase() !== "completed") {
      return "";
    }
    return completedDate ? new Date(completedDate).toLocaleDateString("en-GB") : "";
  };

  const mergedUsers = inactiveAssignedUser ? [...userData, inactiveAssignedUser] : userData;

  return (
    <div className="main-form-container">

      <PageHeader title="Update Job Status" />

      <Snackbar open={openSnackbar} autoHideDuration={4000} onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ whiteSpace: 'pre-line' }}>
          {Array.isArray(snackbarMessage) ? (
            snackbarMessage.map((msg, index) => (
              <div key={index}>{msg}</div>
            ))
          ) : (
            snackbarMessage
          )}
        </Alert>
      </Snackbar>

      <div className="search-and-button-job">
        <Stack direction="row" spacing={2}>
          {(isAdmin || isSubAdmin) &&
            <Button
              onClick={handleFileUpload}
              className="file-upload-button"
              style={{ textTransform: 'none' }}
              startIcon={<CloudUploadIcon />}
              variant="outlined"
              color='inherit'
              disabled={fileName !== null}
            >
              Bulk Job Upload
            </Button>}

          {fileName && (
            <Button
              onClick={handleErrorFile}
              className="file-upload-button"
              style={{ textTransform: 'none' }}
              variant="outlined"
              color="error"
              startIcon={<DownloadIcon />}
            >
              Bulk Job Error File
            </Button>
          )}
        </Stack>
      </div>

      <form onSubmit={handleSubmit} className="form">
        <Grid2 container spacing={2}>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <Autocomplete
              options={clientList}
              getOptionLabel={(option) => option.name || ''}
              value={clientList.find(client => client.id === selectedClientId) || null}
              onChange={(event, newValue) => {
                if (newValue) {
                  handleClientChange({ target: { value: newValue.id } });
                  setShortListedJobs([]);
                } else {
                  setSelectedClientId('');
                  setJobData([]);
                  setJobType([]);
                  setShortListedJobs([]);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Client"
                  margin="normal"
                  fullWidth
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.name}
                </li>
              )}
              disableClearable
            />
          </Grid2>

          {/* Job Type */}
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Autocomplete
              options={jobType}
              getOptionLabel={(option) => option || ''}
              value={selectedJobType || null}
              onChange={(event, newValue) => {
                if (newValue) {
                  handleTypeChange({ target: { value: newValue } });
                } else {
                  setSelectedJobType('');
                  setShortListedJobs([]);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Job Type"
                  margin="normal"
                  fullWidth
                />
              )}
              isOptionEqualToValue={(option, value) => option === value}
              disableClearable
            />
          </Grid2>

          {/* Job Selection */}
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Autocomplete
              options={jobOptions}
              getOptionLabel={(option) => option?.jobName || ''}
              value={jobOptions.find(job => job.jobId === selectedJobId) || null}
              inputValue={jobInput}
              loading={jobLoading}
              onInputChange={(event, newInputValue, reason) => {
                if (reason === 'input') {
                  setJobInput(newInputValue);
                  setInternalJobInput(newInputValue + '  ');
                  setTimeout(() => {
                    setJobInput(newInputValue);
                    setInternalJobInput(newInputValue);
                  }, 10);
                } else {
                  setJobInput(newInputValue);
                  setInternalJobInput(newInputValue);
                }
              }}
              filterOptions={(options, state) => {
                return jobFilter(options, { inputValue: internalJobInput });
              }}
              onChange={(event, newValue) => {
                if (newValue) {
                  handleJobChange({ target: { value: newValue.jobId } });
                  setJobInput(newValue.jobName);
                  setInternalJobInput(newValue.jobName);
                } else {
                  setSelectedJobId('');
                  setJobInput('');
                  setInternalJobInput('');
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Job"
                  margin="normal"
                  fullWidth
                />
              )}
              isOptionEqualToValue={(option, value) => option.jobId === value.jobId}
              renderOption={(props, option) => (
                <li {...props} key={option.jobId}>
                  {option.jobName}
                </li>
              )}
              disableClearable
            />
            {selectedJobId && (
              <Grid2 size={{ xs: 12 }}>
                <Typography variant="body1">
                  Current Status: {currentStatusValue} {formatCompletedDate(jobCompletedDate)}
                </Typography>
              </Grid2>
            )}
          </Grid2>

          {/* Job Status Selection */}
          <Grid2 size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Job Status</InputLabel>
              <Select
                value={(Array.isArray(filteredStatuses) && filteredStatuses.some((s) => s.label === status || s.value === status)) ? status : ''}
                onChange={handleStatusChange}
                label={t('job.status')}
                required
              >
                {loading ? (
                  <MenuItem value="" disabled>
                    <CircularProgress size={24} />
                  </MenuItem>
                ) : filteredStatuses.length > 0 ? (
                  filteredStatuses.map((status) => (
                    <MenuItem key={status.value} value={status.label}>
                      {status.label}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>
                    <span>No statuses available</span>
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid2>

          {/* Job expectedEndDate*/}
          {(status === "Initial review" || status === "Can be start" || status === "In progress") && (
            <Grid2 size={{ xs: 12, md: 6 }}>
              <TextField
                label="Expected End Date"
                type="date"
                fullWidth
                margin="normal"
                slotProps={{
                  inputLabel: { shrink: true },
                  htmlInput: {
                    min: new Date().toISOString().split("T")[0],
                  },
                }}
                value={expectedEndDate}
                onChange={(e) => setExpectedEndDate(e.target.value)}
                required
              />
            </Grid2>
          )}

          {/* User Selection */}
          <Grid2 size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth margin="normal">
              <InputLabel>User</InputLabel>
              <Select
                value={(Array.isArray(mergedUsers) && mergedUsers.some((u) => String(u.id) === String(assignedUserId))) ? assignedUserId : ''}
                onChange={handleUserChange}
                label="User"
                required
              >
                {loading ? (
                  <MenuItem value="" disabled>
                    <div sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <CircularProgress size={24} />
                    </div>
                  </MenuItem>
                ) : userData.length > 0 ? (
                  mergedUsers.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.firstName} {user.middleName} {user.lastName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>
                    <span sx={{ color: 'text.secondary' }}>No users available</span>
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid2>

          {status !== "Completed" && (
            <Grid2 container size={{ xs: 12, md: 6 }} spacing={2} alignItems="center">
              {/* Budget Hours TextField */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  type="number"
                  label={t('job.budget_hours')}
                  variant="outlined"
                  fullWidth
                  value={budgetHours}
                  onChange={(e) => setBudgetHours(e.target.value)}
                  margin="normal"
                  disabled
                />
              </Grid2>

              {/* Budget Hours Button */}
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Button variant="contained" onClick={handleOpenModal}
                  className='form-button-budget'
                  disabled={!selectedJobId}
                >
                  Job Plan
                </Button>

                {/* Modal for Calculate Budget Hours */}
                <CalculateBudgetHours
                  open={openModal}
                  onClose={handleCloseModal}
                  existingData={existingDataBudgetHours}
                  onSave={handleSaveDataJobPlan}
                  jobType={checkType}
                  jobId={selectedJobId}
                  budgetUpdatedByUser={budgetUpdatedByUser}
                  budgetUpdatedAt={budgetUpdatedAt}
                />
              </Grid2>
            </Grid2>
          )}

          {status === "Completed" && (
            <>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  label="Job Completed Date"
                  type="date"
                  fullWidth
                  margin="normal"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  value={jobCompletedDate}
                  onChange={(e) => setJobCompletedDate(e.target.value)}
                  required
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  label="Charge Hours"
                  type="text"
                  fullWidth
                  margin="normal"
                  value={chargeHours}
                  onChange={handleChargeHoursChange}
                  slotProps={{
                    input: { placeholder: 'e.g. 06:30' },
                    inputLabel: { shrink: true },
                  }}
                  error={!!chargeHoursError}
                  helperText={chargeHoursError || 'Format HH:MM'}
                  required
                />
              </Grid2>

            </>

          )}

          {showButton && (
            <Grid2 size={{ xs: 12, md: 6 }} sx={{ marginTop: -1 }}>
              <FormControl fullWidth margin="normal">
                <Button variant="contained" color="primary" onClick={handleOpenModal}
                  style={{ width: '50%', textTransform: 'none', backgroundColor: 'var(--primary)' }}>
                  <CheckCircleIcon sx={{ marginRight: 1 }} />Show Checklist <p> {existingData ? existingData.totalTime : ''}</p>
                </Button>

                <JobCheckList
                  open={openModal}
                  onClose={handleCloseModal}
                  existingData={existingData}
                  isCheckListChecked={isCheckListChecked}
                  onSave={handleSaveData}
                  jobType={checkType}
                />
              </FormControl>
            </Grid2>
          )}

          <Grid2 size={{ xs: 12 }} className="form-actions">
            <Button type="submit" variant="contained" className="form-button-job-status" >
              {t('job.save')}
            </Button>
          </Grid2>
        </Grid2>
      </form>

      <ConfirmationDialog
        open={openReviewDialog}
        onClose={() => setOpenReviewDialog(false)}
        onConfirm={handleConfirmReviewAnyway}
        title="Review Pending"
        message="This job has not been reviewed yet. Do you still want to mark it as completed?"
        confirmLabel="Complete Anyway"
        confirmColor="warning"
      />

      <Dialog
        open={openReasonDialog}
        onClose={() => setOpenReasonDialog(false)}
        slotProps={{ paper: { className: 'modern-dialog' } }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle className="modern-dialog-title">
          <span className="modern-dialog-title-text">Provide Reason</span>
          <IconButton
            aria-label="close"
            onClick={() => setOpenReasonDialog(false)}
            className="modern-dialog-close-btn"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className="modern-dialog-content">
          <Box sx={{ mt: 1 }}>
            <Typography sx={{ mb: 3, fontSize: "0.9rem", color: "#64748b", lineHeight: 1.5 }}>
              You are updating this job from <strong>Review</strong> to a different status.
              <br />
              <span style={{ color: 'var(--primary)', fontWeight: 500, marginTop: '0.75rem', display: 'block' }}>
                Email notification will be sent to the management team.
              </span>
            </Typography>

            <TextField
              fullWidth
              multiline
              minRows={4}
              value={reasonText}
              onChange={(e) => setReasonText(e.target.value)}
              label="Enter reason for status change"
              placeholder="Please provide a detailed reason..."
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '0.75rem',
                  backgroundColor: '#f8fafc'
                }
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions className="modern-dialog-actions">
          <Button
            onClick={() => setOpenReasonDialog(false)}
            variant="outlined"
            color="inherit"
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="primary"
            disabled={!reasonText.trim()}
            onClick={handleConfirmWithReason}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDialogFileUpload}
        onClose={handleCloseDialogFileUpload}
        slotProps={{ paper: { className: 'modern-dialog' } }}
        maxWidth="xs"
      >
        <DialogTitle className="modern-dialog-title">
          <span className="modern-dialog-title-text">Bulk Job Completed</span>
          <IconButton
            aria-label="close"
            onClick={handleCloseDialogFileUpload}
            className="modern-dialog-close-btn"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className="modern-dialog-content">
          <Box sx={{ mt: 1 }}>
            <Input
              id="file-upload"
              type="file"
              accept=".xls, .xlsx"
              onChange={handleFileUploadChange}
              sx={{ display: 'none' }}
            />
            <label htmlFor="file-upload">
              <Box className="file-upload-area">
                <CloudUploadIcon className="file-upload-icon" />
                <Typography variant="body1" sx={{ fontWeight: 600, color: '#334155' }}>
                  Click to select file
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5 }}>
                  Support for .xls, .xlsx files
                </Typography>

                {fileUpload && (
                  <Box className="selected-file-name">
                    {fileUpload.name}
                  </Box>
                )}
              </Box>
            </label>

            <Box sx={{ mt: 2 }}>
              <Typography variant="caption" sx={{ color: '#94a3b8', display: 'block', textAlign: 'center' }}>
                Please ensure you use the standard template for uploads.
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions className="modern-dialog-actions">
          <Button
            onClick={handleBulkJobFormat}
            variant="outlined"
            sx={{
              borderColor: '#10b981',
              color: '#10b981',
              '&:hover': { borderColor: '#059669', backgroundColor: 'rgba(16, 185, 129, 0.04)' }
            }}
            startIcon={<GetApp />}
          >
            Format
          </Button>
          <Box sx={{ flexGrow: 1 }} />
          <Button
            onClick={handleCloseDialogFileUpload}
            variant="outlined"
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            onClick={handleFileUploadApi}
            color="primary"
            variant='contained'
            disabled={isUploading || !fileUpload}
          >
            {isUploading ? "Uploading..." : "Upload"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openUnreviewedModal}
        onClose={() => setOpenUnreviewedModal(false)}
        maxWidth="md"
        fullWidth
        slotProps={{ paper: { className: 'modern-dialog' } }}
      >
        <DialogTitle className="modern-dialog-title">
          <span className="modern-dialog-title-text">Unreviewed Jobs</span>
          <IconButton
            aria-label="close"
            onClick={() => setOpenUnreviewedModal(false)}
            className="modern-dialog-close-btn"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className="modern-dialog-content">
          <Box sx={{ mt: 1, mb: 2 }}>
            <Typography sx={{ color: '#64748b', fontSize: '0.95rem' }}>
              These jobs have not been reviewed yet. Select the jobs you want to complete.
            </Typography>
          </Box>

          {unreviewedJobs.length > 0 ? (
            <Box sx={{ overflow: "hidden", borderRadius: '0.75rem', border: '1px solid #e2e8f0' }}>
              <Table stickyHeader size="small" className="checklist-table" style={{ margin: 0, border: 'none', borderRadius: 0 }}>
                <TableHead>
                  <TableRow>
                    <TableCell width="160" sx={{ backgroundColor: '#f8fafc !important' }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0 }}>
                        <Checkbox
                          indeterminate={
                            selectedUnreviewedJobs.length > 0 &&
                            selectedUnreviewedJobs.length < unreviewedJobs.length
                          }
                          checked={
                            unreviewedJobs.length > 0 &&
                            selectedUnreviewedJobs.length === unreviewedJobs.length
                          }
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedUnreviewedJobs(unreviewedJobs);
                            } else {
                              setSelectedUnreviewedJobs([]);
                            }
                          }}
                          sx={{ color: '#94a3b8' }}
                        />
                        <Typography variant="caption" sx={{ fontWeight: 600, color: '#64748b', textTransform: 'uppercase' }}>
                          Select All
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc !important', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', fontSize: '0.7rem' }}>Job Name</TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc !important', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', fontSize: '0.7rem' }}>Job Type</TableCell>
                    <TableCell sx={{ backgroundColor: '#f8fafc !important', fontWeight: 600, color: '#64748b', textTransform: 'uppercase', fontSize: '0.7rem' }}>Client Code</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {unreviewedJobs.map((job) => {
                    const isSelected = selectedUnreviewedJobs.some((j) => j.jobId === job.jobId);

                    return (
                      <TableRow key={job.jobId} hover>
                        <TableCell sx={{ verticalAlign: "middle" }}>
                          <Checkbox
                            checked={isSelected}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedUnreviewedJobs((prev) => [...prev, job]);
                              } else {
                                setSelectedUnreviewedJobs((prev) =>
                                  prev.filter((j) => j.jobId !== job.jobId)
                                );
                              }
                            }}
                          />
                        </TableCell>

                        <TableCell sx={{ fontWeight: 500 }}>{job.jobName}</TableCell>
                        <TableCell>
                          <Box sx={{ backgroundColor: '#f1f5f9', px: 1, py: 0.5, borderRadius: '0.25rem', display: 'inline-block', fontSize: '0.75rem' }}>
                            {job.jobType}
                          </Box>
                        </TableCell>
                        <TableCell sx={{ color: '#64748b', fontStyle: 'italic' }}>{job.clientCode}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          ) : (
            <Box sx={{ py: 4, textAlign: 'center' }}>
              <Typography sx={{ color: '#94a3b8' }}>No unreviewed jobs found.</Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions className="modern-dialog-actions">
          <Button variant="outlined" color="inherit" onClick={() => setOpenUnreviewedModal(false)}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="primary"
            disabled={selectedUnreviewedJobs.length === 0}
            onClick={async () => {
              try {
                await jobServices.forceCompleteJobs({ jobs: selectedUnreviewedJobs });

                setSnackbarMessage(`${selectedUnreviewedJobs.length} jobs completed successfully!`);
                setSnackbarSeverity("success");
                setOpenSnackbar(true);

                setOpenUnreviewedModal(false);
                setSelectedUnreviewedJobs([]);
                setUnreviewedJobs([]);
                fetchData();
              } catch (err) {
                setSnackbarMessage("Failed to complete jobs. Try again.");
                setSnackbarSeverity("error");
                setOpenSnackbar(true);
              }
            }}
          >
            Complete Anyway
          </Button>
        </DialogActions>
      </Dialog>

      <ActionProgressDialog open={isUploading} message={actionMessage} />
    </div>
  );
};

export default JobStatus;
